import buildRequestUrl from "lib/requests/requestUtils";
import { apolloClient } from "lib/axios/clients";
import { REACT_APP_APOLLO_URL } from "resources/constants";

const recommendationEngineUserAction = async (data = {}) => {
  const config = {
    method: "POST",
    url: buildRequestUrl({}, "user_actions", REACT_APP_APOLLO_URL),
    data,
  };

  apolloClient.request(config);
};

export const recommendationGetActionsRecommend = async (urlParams) => {
  const config = {
    method: "GET",
    url: buildRequestUrl(
      urlParams,
      "actions_recommended",
      REACT_APP_APOLLO_URL
    ),
  };

  const response = await apolloClient.request(config);
  return response;
};

export const recommendationGetActions = async (urlParams) => {
  const config = {
    method: "GET",
    url: buildRequestUrl(urlParams, "actions", REACT_APP_APOLLO_URL),
  };

  const response = await apolloClient.request(config);
  return response;
};

export default recommendationEngineUserAction;
